import styled from 'styled-components';

export const AutocompleteBlock = styled.div`
  position: relative;
  flex: 1;
  min-width: 190px;
  border: 1px solid #d5d5d6;
  border-radius: 4px;
  background-color: #fafafa;
`;
